// extracted by mini-css-extract-plugin
export var deleteIcon = "_ug-5";
export var deleteOption = "_ug-3";
export var divider = "_ug-2";
export var downloadIcon = "_ug-4";
export var drawer = "_ug-0";
export var drawerFooter = "_ug-6";
export var drawerOpen = "_ug-1";
export var highlighted = "_ug-7";
export var lighterHighlight = "_ug-8";